
import { useSurveysStore, abortSurveysApi, useSurveysApi } from '@widgets/surveys'
import { useOnTimezoneChange } from '@entities/viewer'
import { resolveUrl } from '@shared/lib/url'
import { AppRoute } from '@shared/config'

interface DisciplineSurveysReturn {
  refIsFirstLoad: ComputedRef<boolean>
}

/** The discipline's surveys on the shared surveys store: the first read shares the page loader with the discipline,
 *  and the rows are dropped on leaving so the global Surveys page never opens on them. */
export const useDisciplineSurveys = (): DisciplineSurveysReturn => {
  const route = useRoute()
  const store = useSurveysStore()

  const refIsFirstLoad = computed<boolean>(() => store.isLoading && store.getMeta === null)

  const isSurveysPath = (): boolean =>
    route.path === resolveUrl(AppRoute.DisciplinesSurveys, { id: route.params.id as string })

  onMounted(() => {
    void useSurveysApi()
  })

  // Filters and pagination navigate by query, so the table follows the URL.
  watch(() => route.query, () => {
    if (isSurveysPath()) {
      void useSurveysApi()
    }
  })

  // Timestamps arrive pre-shifted into the admin's view timezone.
  useOnTimezoneChange(() => {
    void useSurveysApi()
  })

  onBeforeUnmount(() => {
    abortSurveysApi()
    store.resetList()
  })

  return {
    refIsFirstLoad,
  }
}
